import { APP } from '../../redux/constants/app.constants';

export const SCENARIOS_PAGE = `${APP}/scenarios_page`;
export const SCENARIOS_PAGE_MODE = `${APP}/SCENARIOS_PAGE_MODE`;
export const TEST_SCENARIO_ACTION = `${SCENARIOS_PAGE}/TEST_SCENARIO_ACTION`;
export const SET_IS_LOADING = `${SCENARIOS_PAGE}/SET_IS_LOADING`;
export const SCENARIO_TEMPLATES_CHANGED = `${SCENARIOS_PAGE}/SCENARIO_TEMPLATES_CHANGED`;
export const GET_SCENARIO_TEMPLATES = `${SCENARIOS_PAGE}/GET_SCENARIO_TEMPLATES`;
export const SAVE_SCENARIO_TEMPLATE = `${SCENARIOS_PAGE}/SAVE_SCENARIO_TEMPLATE`;